/* Animation pulse */
export const pulseElement = (element) => {
  element.classList.add("pulse");
  setTimeout(function () {
    element.classList.remove("pulse");
  }, 400);
};
